"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _alloyReactTag = _interopRequireDefault(require("@adsk/alloy-react-tag"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Spacer = _interopRequireDefault(require("../shared/Spacer"));

var _mediaDetailContext = require("./media-detail-context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const TagContainer = _styledComponents.default.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
`;

const Tags = ({
  values = [],
  leadingSpace,
  tagStyle
}) => {
  const {
    mediaHandlers: {
      removeTagsHandler
    }
  } = (0, _mediaDetailContext.useMedia)();
  const removeTag = (0, _react.useCallback)(tag => removeTagsHandler([tag]), [removeTagsHandler]);
  return /*#__PURE__*/_react.default.createElement(TagContainer, null, /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    key: "tag-leading-spacer",
    width: leadingSpace
  }), values.map((value, i) => [/*#__PURE__*/_react.default.createElement(_alloyReactTag.default, {
    style: tagStyle,
    key: i + value.name,
    onClose: () => removeTag(value)
  }, value.name), /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    key: i + "tag-name-spacer-back",
    width: 5
  })]));
};

var _default = Tags;
exports.default = _default;